import defaultData from './mock-new.default.json';
import rtkData from './mock-new.rtk.json';
const data = process.env.REACT_APP_THEME === 'rtk' ? rtkData : defaultData;
export default data;
